import { render } from "./PayingRegistrationApp.vue?vue&type=template&id=10101a98&ts=true"
import script from "./PayingRegistrationApp.vue?vue&type=script&lang=ts"
export * from "./PayingRegistrationApp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__